/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CompetenceId200,
  GetApiV1CompetenceId401,
  GetApiV1CompetenceId404,
  GetApiV1CompetenceId500,
  GetApiV1CompetenceIdPathParams,
  GetApiV1CompetenceIdQueryParams,
  GetApiV1CompetenceIdQueryResponse,
} from "../../types/competenceRegistroController/GetApiV1CompetenceId.ts";
import { competenceViewModelSchema } from "../competenceViewModelSchema.ts";

export const getApiV1CompetenceIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CompetenceIdPathParams>;

export const getApiV1CompetenceIdQueryParamsSchema = z
  .object({
    culture: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1CompetenceIdQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CompetenceId200Schema = z.lazy(
  () => competenceViewModelSchema,
) as unknown as ToZod<GetApiV1CompetenceId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CompetenceId401Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CompetenceId404Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CompetenceId500Schema =
  z.any() as unknown as ToZod<GetApiV1CompetenceId500>;

export const getApiV1CompetenceIdQueryResponseSchema = z.lazy(
  () => getApiV1CompetenceId200Schema,
) as unknown as ToZod<GetApiV1CompetenceIdQueryResponse>;
